import {
  SET_CREDITS,
  SET_ACTIVE_PLAN,
  RESET_PAY_STATE,
  SET_CREDITS_SEED,
  GET_ALL_INVOICES,
  SET_BILLING_DETAILS,
  SET_AUTO_PAY_CREDITS,
} from "../types";

const initialState = {
  credits: {},
  seedCreds: [],
  activePlan: null,
  billDetails: {},
  autoPay: {},
  InvObj: {},
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CREDITS_SEED:
      return {
        ...state,
        seedCreds: action.payload,
      };
    case SET_CREDITS:
      return {
        ...state,
        credits: action.payload,
      };
    case SET_AUTO_PAY_CREDITS:
      return {
        ...state,
        autoPay: action.payload,
      };
    case SET_ACTIVE_PLAN:
      return {
        ...state,
        activePlan: action.payload,
      };
    case SET_BILLING_DETAILS:
      return {
        ...state,
        billDetails: action.payload,
      };
    case GET_ALL_INVOICES:
      return {
        ...state,
        InvObj: action.payload,
      };
    case RESET_PAY_STATE:
      return initialState;
    default:
      return state;
  }
};

export default paymentReducer;
